// src/utils/time.js
export function toMillis(value) {
  if (!value) return null;

  // Firestore Timestamp (web SDK) has toMillis()
  if (typeof value.toMillis === "function") return value.toMillis();

  // Firestore Timestamp-like object { seconds, nanoseconds }
  if (typeof value?.seconds === "number") return value.seconds * 1000;

  // JS Date
  if (value instanceof Date) return value.getTime();

  // Already a number (assume ms)
  if (typeof value === "number") return value;

  return null;
}
